import { useState } from "react";
import CommonModal from "./DumpModal";
import InputField from "./InputField";

const CautionIcon = () => (
  <span className="text-red-600">🚨 Proceed with caution:</span>
);

const ConfirmModal = ({ isOpen, onClose, title, onConfirm, loading }) => {
  const [input, setInput] = useState("");
  return (
    <CommonModal
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      alertIcon={input === "CONFIRM" ? <CautionIcon /> : null}
      alertType={input === "CONFIRM" ? "danger" : "warning"}
    >
      <div className="mt-4">
        <label htmlFor="confirm" className="text-muted-foreground text-md">
          Type CONFIRM to proceed
        </label>
        <InputField
          id="confirm"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={"Type CONFIRM to proceed"}
          classNames={"mt-2 focus:!border-border"}
        />
        <button
          className={`mt-4 text-center w-full rounded-md py-3 text-lg ${
            input === "CONFIRM"
              ? "bg-primary text-primary-foreground"
              : "border !border-border bg-muted text-muted-foreground"
          }`}
          onClick={onConfirm}
          disabled={loading || input !== "CONFIRM"}
        >
          {loading ? (
            <div className="w-full h-full flex items-center justify-center">
              <div
                class="spinner"
                style={{
                  width: "22px",
                  height: "22px",
                  display: "inline-block",
                  marginRight: "8px",
                }}
              ></div>
            </div>
          ) : (
            "Confirm Change"
          )}
        </button>
      </div>
    </CommonModal>
  );
};

export default ConfirmModal;
